import {Dialog} from "./common";
import {toRange, escapeSheet} from "../helpers/column_names";

export const action = "find";

export class DialogBox extends Dialog{
	$show(box, form){
		form.setValues({
			within: "sheet",
			in: "formulas"
		});
		form.getChildViews()[1].clearAll();
		form.focus();
	}
	$hide(){
		delete this.sheetUpdated;
		delete this.settings;
	}
	$init(){
		this.view.attachEvent("onChange", () => {
			if(this.$dialog.isVisible())
				this.sheetUpdated = true;
		});

		const locale = webix.i18n.spreadsheet.labels;
		const readonly = this.view.config.readonly;
		return {
			view: "ssheet-dialog",
			width: 700,
			head: locale[readonly ? "find-title" : "find-replace-title"],
			move: true,
			buttons: false,
			position: "center",
			body:{
				view:"form",
				elementsConfig: {
					labelWidth: 120
				},
				elements:[
					{ cols:[
						{ width: 320, rows:[
							{ view:"text", name:"find", label:locale["find-what"]},
							{ view:"text", name:"replace", label:locale["replace-with"], hidden: readonly},	
						]},
						{width:10},
						{ rows:[
							{ view:"combo", name:"within", value:"sheet", labelWidth: 180, label:locale["find-within"], options:[
								{id: "sheet", value:locale["find-sheet"]},
								{id: "book", value:locale["find-book"]}
							]},
							{ view:"combo", name:"in", value:"formulas", labelWidth: 180, label:locale["find-look-in"], options:[
								{id: "formulas", value:locale["find-formulas"]},
								{id: "values", value:locale["find-values"]}
							]},
							{ view:"checkbox", name:"case", labelWidth: 180, label:locale["find-match-case"]},
							{ view:"checkbox", name:"same", labelWidth: 180, label:locale["find-match-entire-content"]},
						]}
					]},
					{ view: "ssheet-dialog-table", id: "table", resizeColumn:true, borderless:true,
						columns:[
							{ id:"sheet", header:locale["find-all-sheet"], width:150 },
							{ id:"cell", header:locale["find-all-cell"] },
							{ id:"value", header:locale["find-all-value"], fillspace:true },
							{ id:"formula", header:locale["find-all-formula"], fillspace:true },
						],
						height: 150,
						scroll:"y",
						select:"row",
						on:{
							onAfterSelect: ()=> {
								const item = this.$dialog.$$("table").getSelectedItem();

								this.view.showCell(escapeSheet(item.sheet)+"!"+item.cell);
							}
						}
					},
					{
						cols:[
							{ },
							{ view: "button", css:"ssheet_cancel_button", hotkey:"esc",
								value: locale.cancel, autowidth:true,
								click: () => this.close()
							},
							{ view: "button", label: locale["replace-all"], hidden: readonly, autowidth:true,
								click: () => this.replaceAll()
							},
							{ view: "button", label: locale["replace"], hidden: readonly, autowidth:true,
								click: () => this.replace()
							},
							{ view: "button", label: locale["find-all"], autowidth:true,
								click: () => {
									this.findAll(true);
									this.findNext();
								}
							},
							{ view: "button", label: locale["find-next"], autowidth:true,
								click: () => this.findNext()
							},
						]
					}
				]
			}
		};
	}
	replaceAll(){
		const settings = this.$dialog.getBody().getValues();

		this.view.groupUndo(()=>{
			this.findAll().forEach(item => this.setNewValue(item, settings));
			this.view.refresh();
		});

		this.$dialog.$$("table").clearAll();
	}
	replace(){
		const settings = this.$dialog.getBody().getValues();
		const sel = this.view.getSelectedId();
		if(sel && settings.find){
			const sheet = this.view.getActiveSheet();
			const check = this.findCheck(
				this.view.getCellValue(sel.row, sel.column, settings.in == "formulas"),
				sel.row,
				sel.column,
				sheet,
				settings,
				[]
			);
			if(check.length){
				this.setNewValue(check[0], settings);
				this.view.refresh();
				const table = this.$dialog.$$("table");
				if(table.count()){
					this.findNext();
					const item = table.find(item => item.row == sel.row && item.col == sel.column && item.sheet == sheet, true);
					table.remove(item.id);
				}
			}
		}
	}
	setNewValue(item, settings){
		const find = new RegExp(settings.find.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&"), settings.case ? "g" : "ig");
		this.view.setCellValue(
			item.row,
			item.col,
			((settings.in == "formulas" ? item["formula"] || item["value"] : item["value"])+"").replace(find, settings.replace),
			item.sheet
		);
	}
	findAll(updateTable){
		const table = this.$dialog.$$("table");
		if(updateTable)
			table.clearAll();

		const settings = this.$dialog.getBody().getValues();
		if(!settings.find) return [];

		const data = [];

		if(settings.within == "sheet")
			this.view.$$("cells").eachColumn(col => 
				this.view.$$("cells").eachRow(row => 
					this.findCheck(this.view.getCellValue(row, col, settings.in == "formulas"), row, col, this.view.getActiveSheet(), settings, data)
				)
			);
		else
			this.view.serialize({sheets: true, math: settings.in == "formulas"}).forEach(sheet => {
				if(sheet.state == "visible")
					sheet.content.data.forEach(item => this.findCheck(item[2], item[0], item[1], sheet.name, settings, data));
			});

		if(updateTable)
			table.parse(data);

		return data;
	}
	findCheck(val, row, col, sheet, settings, result){
		let compare =  settings.find;
		if(!settings.case)
			compare = settings.find.toLowerCase();

		let checkVal = val+"";
		if(!settings.case)
			checkVal = checkVal.toLowerCase();

		if((settings.same && checkVal == compare) || (!settings.same && checkVal.indexOf(compare) != -1)){
			let formula = (settings.in == "formulas" ? val : this.view.getCellValue(row, col, true, sheet))+"";
			if(!(formula.indexOf("=") == 0 && formula.length > 1))
				formula = "";
			const value = settings.in == "formulas" ? this.view.getCellValue(row, col, false, sheet) : val;

			result.push({ row, col, sheet, value, formula, cell:toRange(row, col) });
		}
		return result;
	}
	findNext(){
		const table = this.$dialog.$$("table");

		let settings = this.$dialog.getBody().getValues();
		delete settings.replace;
		settings = JSON.stringify(settings);

		if(this.sheetUpdated || !table.count() || (this.settings && settings != this.settings)){
			this.settings = settings;
			this.findAll(true);
		}

		if(table.count()){
			let sel = table.getSelectedId();

			if(!sel){
				const spreadsheetSel = this.view.getSelectedId();
				if(spreadsheetSel){
					const selectedItem = table.find(item => item.row == spreadsheetSel.row && item.col == spreadsheetSel.column && item.sheet == this.view.getActiveSheet(), true);
					if(selectedItem)
						sel = selectedItem.id;
				}
			}

			const next = sel ? table.getNextId(sel) || table.getFirstId() : table.getFirstId();
			table.select(next);
			table.showItem(next);
		}
	}
}